var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsValidationCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F7350A42-AE28-4EAC-B040-0748979FD593") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-1-4-DhurvStar-Design-System",
    transform: "translate(-492.000000, -469.000000)",
    fill: "#2CE68F"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.-Icons/ic_validation_check",
    transform: "translate(492.000000, 469.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2015113,0.049999965 C18.912142,0.049999965 24.3521831,5.40019722 24.3521831,12 C24.3521831,18.5998028 18.912142,23.95 12.2015113,23.95 C5.49088063,23.95 0.050839595,18.5998028 0.050839595,12 C0.050839595,5.40019722 5.49088063,0.049999965 12.2015113,0.049999965 Z M12.2015113,1.54999996 C6.33321921,1.54999996 1.57602851,6.22862435 1.57602851,12 C1.57602851,17.7713757 6.33321921,22.45 12.2015113,22.45 C18.0698035,22.45 22.8269942,17.7713757 22.8269942,12 C22.8269942,6.22862435 18.0698035,1.54999996 12.2015113,1.54999996 Z M17.903614,7.78052388 C18.1915518,8.03742848 18.2336948,8.46133843 18.0158977,8.76632675 L17.9560248,8.83993083 L11.1963875,16.1679309 C10.915267,16.4726885 10.4429123,16.4943481 10.1346033,16.2329951 L10.0665289,16.167659 L6.44674718,12.239659 C6.16391292,11.9327419 6.18761403,11.4584406 6.49968509,11.1802774 C6.78775069,10.9235114 7.22083451,10.9236216 7.50821507,11.1665566 L7.57685648,11.232341 L10.6310751,14.5475 L16.8264168,7.83206915 C17.1094038,7.52528816 17.5916814,7.50221056 17.903614,7.78052388 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsValidationCheck);
export default __webpack_public_path__ + "static/media/is_validation_check.d2207f870c247c19bbabe144fe2d46dc.svg";
export { ForwardRef as ReactComponent };